module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 008.5dfca390.jpg";